import { Component, Input } from '@angular/core';

@Component({
  selector: 'psc-line',
  styleUrls: ['line.component.scss'],
  templateUrl: './line.component.html',
})
export class LineComponent {

  @Input() thickness: number = 4;
  @Input() color: string = 'bg-sun-yellow';

}
